{
  "application": {
    "error": {
      "description": "Bei der Bearbeitung deiner Anfrage ist ein Fehler aufgetreten. Bitte versuche es erneut.",
      "title": "Fehler"
    }
  },
  "billingPage": {
    "addressVerification": {
      "error": {
        "text": "Bitte prüfen Sie Ihre Rechnungsadresse oder wählen Sie Direktzahlung, um fortzufahren.",
        "title": "Adresse konnte nicht verifiziert werden"
      }
    },
    "billingForm": {
      "billTo": "Rechnungsadresse",
      "city": "Ort",
      "company": "Firma",
      "companyName": "Firmenname",
      "country": "Land",
      "email": {
        "helperText": "Kontaktanfragen werden zu dieser E-Mail Adresse gesendet. Sie wird nicht veröffentlicht.",
        "title": "E-Mail",
        "tooltip": "Die hier bereits eingefügte E-Mail-Adresse entspricht derjenigen in deinem Benutzerkonto. Falls du es wünschst, kannst du sie dort ändern."
      },
      "header": {
        "label": "Persönliche Angaben"
      },
      "invoiceLanguage": "Rechnungssprache",
      "invoiceType": {
        "email": "E-mail",
        "emailAndPostal": "Post",
        "text": "Die Rechnung wird per E-Mail verschickt.",
        "title": "Versandart der Rechnung"
      },
      "name": "Vorname & Nachname",
      "person": "Person",
      "phone": "Telefon",
      "salutation": {
        "mr": "Herr",
        "mrs": "Frau",
        "noSalutation": "Keine Anrede",
        "title": "Anrede"
      },
      "streetAndNumber": "Strasse & Nummer",
      "zipCode": "PLZ"
    },
    "costSummary": {
      "header": {
        "label": "MieterPlus"
      },
      "package": {
        "price": " pro Monat",
        "startDate": "Das 3-monatige Abonnement beginnt am {startDate}",
        "variable": {
          "startDate": "Das {month}-monatige Abonnement beginnt am {startDate}."
        }
      },
      "trial": {
        "price": "7 Tage Gratis-Probeabo",
        "startDate": "Beginnt nach der Bestellung und läuft am {expiredDate} um 23:59 Uhr (CET) ab."
      }
    },
    "fdt": {
      "consentCheckbox": {
        "error": "Bitte bestätigen",
        "text": "Ich bestätige, dass ich das 3-monatige Abonnement für CHF 39.95 pro Monat abschliessen möchte. ",
        "trial": {
          "text": "Ich nehme zur Kenntnis, dass nach der 7-tägigen Probezeit das 3-monatige Abonnement für CHF 39.95 pro Monat automatisch startet, sofern ich innerhalb der Probezeit nicht kündige."
        }
      },
      "message": {
        "cta": "Details zum 3-monatigen Abo",
        "text": "Danke für dein Interesse. Bald werden weitere Abonnementstypen zu verschiedenen Preisen im Angebot sein!",
        "title": "Zurzeit ist nur das 3-monatige Abonnement erhältlich"
      }
    },
    "paymentMethod": {
      "creditcard": "Kreditkarte",
      "description": "Wir verwenden deine Rechnungsadresse ausschliesslich zur Zustellung der Rechnung deiner Inserate sowie allfälliger weiterer Zahlungsinformationen. Bitte erfasse die Anschrift so, wie sie auf der Rechnung erscheinen soll.",
      "direct": "Direktzahlung",
      "error": {
        "text": "Leider können wir die Zahlung mit deiner Karte oder Twint nicht verarbeiten. Bitte überprüfe deine Angaben, versuche es noch einmal oder wähle ein anderes Zahlungsmittel.",
        "title": "Problem mit der Zahlung"
      },
      "errorMultipleRequest": {
        "text": "Aufgrund mehrerer erfolgloser Versuche wurde dein Konto für den Rest des Tages gesperrt. Bitte versuche es morgen wieder."
      },
      "header": {
        "label": "Zahlungsmethode",
        "yourSelection": "Deine Auswahl"
      },
      "invoice": "Rechnung",
      "title": "Zahlungsmethode",
      "twint": "Twint"
    },
    "termsAndConditions": {
      "errorMessage": "Bitte stimme den AGB zu, bevor du fortfährst.",
      "label": "Ich akzeptiere die <a href=\"https://www.homegate.ch/c/de/ueber-uns/rechtliches/agb#tenantplus\" target=\"_blank\">AGB</a>."
    },
    "title": "Abrechnung"
  },
  "general": {
    "buttons": {
      "back": "Zurück",
      "startPayment": "Zur Bezahlung",
      "subscribe": "Abschliessen"
    },
    "countries": {
      "ad": "Andorra",
      "ae": "Vereinigte Arabische Emirate",
      "af": "Afghanistan",
      "ag": "Antigua und Barbuda",
      "ai": "Anguilla",
      "al": "Albanien",
      "am": "Armenien",
      "an": "Niederländische Antillen",
      "ao": "Angola",
      "aq": "Antarktis",
      "ar": "Argentinien",
      "as": "Amerikanisch-Samoa",
      "at": "Österreich",
      "au": "Australien",
      "aw": "Aruba",
      "ax": "Aaland-Inseln",
      "az": "Aserbaidschan",
      "ba": "Bosnien und Herzegowina",
      "bb": "Barbados",
      "bd": "Bangladesch",
      "be": "Belgien",
      "bf": "Burkina Faso",
      "bg": "Bulgarien",
      "bh": "Bahrain",
      "bi": "Burundi",
      "bj": "Benin",
      "bm": "Bermuda",
      "bn": "Brunei",
      "bo": "Bolivien",
      "br": "Brasilien",
      "bs": "Bahamas",
      "bt": "Bhutan",
      "bv": "Bouvet-Insel",
      "bw": "Botsuana",
      "by": "Belarus",
      "bz": "Belize",
      "cc": "Kokos-Inseln",
      "cf": "Zentralafrikanische Republik",
      "cg": "Kongo",
      "ch": "Schweiz",
      "ci": "Elfenbeinküste",
      "ck": "Cook-Inseln",
      "cl": "Chile",
      "cm": "Kamerun",
      "cn": "China",
      "co": "Kolumbien",
      "cr": "Costa Rica",
      "cu": "Kuba",
      "cv": "Kap Verde",
      "cx": "Weihnachtsinsel",
      "cy": "Zypern",
      "cz": "Tschechische Republik",
      "de": "Deutschland",
      "dj": "Dschibuti",
      "dk": "Dänemark",
      "do": "Dominikanische Republik",
      "dz": "Algerien",
      "ec": "Ecuador",
      "ee": "Estland",
      "eg": "Ägypten",
      "eh": "Westsahara",
      "er": "Eritrea",
      "es": "Spanien",
      "et": "Äthiopien",
      "fi": "Finnland",
      "fj": "Fidschi",
      "fk": "Falkland-Inseln",
      "fm": "Mikronesien",
      "fo": "Färöer-Inseln",
      "fr": "Frankreich",
      "ga": "Gabun",
      "gb": "Vereinigtes Königreich",
      "gd": "Grenada",
      "ge": "Georgien",
      "gf": "Französisch-Guayana",
      "gh": "Ghana",
      "gi": "Gibraltar",
      "gl": "Grönland",
      "gm": "Gambia",
      "gn": "Guinea",
      "gp": "Guadeloupe",
      "gq": "Äquatorial-Guinea",
      "gr": "Griechenland",
      "gs": "Süd-Georgia und die südlichen Sandwich-Inseln",
      "gt": "Guatemala",
      "gu": "Guam",
      "gw": "Guinea-Bissau",
      "gy": "Guyana",
      "hk": "Hongkong",
      "hm": "Heard- und McDonald-Inseln",
      "hn": "Honduras",
      "hr": "Kroatien",
      "ht": "Haiti",
      "hu": "Ungarn",
      "id": "Indonesien",
      "ie": "Irland",
      "il": "Israel",
      "in": "Indien",
      "io": "Britische Territorien im Indischen Ozean",
      "iq": "Irak",
      "ir": "Iran",
      "is": "Island",
      "it": "Italien",
      "jm": "Jamaika",
      "jo": "Jordanien",
      "jp": "Japan",
      "ke": "Kenia",
      "kg": "Kirgistan",
      "kh": "Kambodscha",
      "ki": "Kiribati",
      "km": "Komoren",
      "kn": "Saint Kitts und Nevis",
      "kp": "Nordkorea",
      "kr": "Südkorea",
      "kw": "Kuwait",
      "ky": "Kaiman-Inseln",
      "kz": "Kasachstan",
      "la": "Laos",
      "lb": "Libanon",
      "lc": "St. Lucia",
      "li": "Liechtenstein",
      "lk": "Sri Lanka",
      "lr": "Liberia",
      "ls": "Lesotho",
      "lt": "Litauen",
      "lu": "Luxemburg",
      "lv": "Lettland",
      "ly": "Libyen",
      "ma": "Marokko",
      "mc": "Monaco",
      "md": "Moldau",
      "me": "Montenegro",
      "mg": "Madagaskar",
      "mh": "Marshall-Inseln",
      "mk": "Mazedonien",
      "ml": "Mali",
      "mm": "Myanmar",
      "mn": "Mongolei",
      "mo": "Macao",
      "mp": "Nördliche Mariannen-Inseln",
      "mq": "Martinique",
      "mr": "Mauretanien",
      "ms": "Montserrat",
      "mt": "Malta",
      "mu": "Mauritius",
      "mv": "Maldiven",
      "mw": "Malawi",
      "mx": "Mexiko",
      "my": "Malaysia",
      "mz": "Mosambik",
      "na": "Namibia",
      "nc": "Neukaledonien",
      "ne": "Niger",
      "nf": "Norfolk-Insel",
      "ng": "Nigeria",
      "ni": "Nicaragua",
      "nl": "Niederlande",
      "no": "Norwegen",
      "np": "Nepal",
      "nr": "Nauru",
      "nu": "Niue",
      "nz": "Neuseeland",
      "om": "Oman",
      "pa": "Panama",
      "pe": "Peru",
      "pf": "Französisch-Polynesien",
      "pg": "Papua-Neuguinea",
      "ph": "Philippinen",
      "pk": "Pakistan",
      "pl": "Polen",
      "pm": "St. Pierre und Miquelon",
      "pn": "Pitcairn",
      "pr": "Puerto Rico",
      "ps": "Palästina",
      "pt": "Portugal",
      "pw": "Palau",
      "py": "Paraguay",
      "qa": "Katar",
      "re": "Reunion",
      "ro": "Rumänien",
      "rs": "Serbien",
      "ru": "Russland",
      "rw": "Ruanda",
      "sa": "Saudi-Arabien",
      "sb": "Solomon-Inseln",
      "sc": "Seychellen",
      "sd": "Sudan",
      "se": "Schweden",
      "sg": "Singapur",
      "sh": "St. Helena",
      "si": "Slowenien",
      "sj": "Svalbard und Jan Mayen",
      "sk": "Slowakei",
      "sl": "Sierra Leone",
      "sm": "San Marino",
      "sn": "Senegal",
      "so": "Somalia",
      "sr": "Suriname",
      "st": "Sao Tome und Principe",
      "sv": "El Salvador",
      "sy": "Syrien",
      "sz": "Swasiland",
      "tc": "Turks- und Caicos-Inseln",
      "td": "Tschad",
      "tf": "Französische Südgebiete",
      "tg": "Togo",
      "th": "Thailand",
      "tj": "Tadschikistan",
      "tk": "Tokelau",
      "tl": "Timor-Leste",
      "tm": "Turkmenistan",
      "tn": "Tunesien",
      "to": "Tonga",
      "tr": "Türkei",
      "tt": "Trinidad und Tobago",
      "tv": "Tuvalu",
      "tw": "Taiwan",
      "tz": "Tansania",
      "ua": "Ukraine",
      "ug": "Uganda",
      "um": "Übrige Inseln im Pazifik der USA",
      "uy": "Uruguay",
      "uz": "Usbekistan",
      "va": "Vatikanstadt",
      "vc": "St. Vincent und die Grenadinen",
      "ve": "Venezuela",
      "vg": "Britische Jungferninseln",
      "vi": "Amerikanische Jungferninseln",
      "vn": "Vietnam",
      "vu": "Vanuatu",
      "wf": "Wallis und Futuna",
      "ws": "Samoa",
      "ye": "Jemen",
      "yt": "Mayotte",
      "za": "Südafrika",
      "zm": "Sambia",
      "zw": "Simbabwe"
    },
    "gbcLink": "https://www.homegate.ch/c/de/ueber-uns/rechtliches/agb",
    "months": "{months} Monate",
    "requiredFields": "Erforderliche Angaben"
  },
  "landing": {
    "benefits": {
      "benefit3": "Einblick in die Inseratsnachfrage",
      "benefit4": "Mit dem Verifiziert-Etikett Aufmerksamkeit erregen",
      "benefit6": "Rabatt für Reinigungs- und Umzugsdienste",
      "captionCleaningAndMoving": {
        "text": "Im 6- und 3-Monats-Abonnement enthalten"
      }
    },
    "androidWebViewOverlay": {
      "title": "MieterPlus",
      "message": "Während wir an einer besseren Lösung arbeiten, öffnen Sie bitte einen externen Webbrowser, um fortzufahren."
    }
  },
  "packages": {
    "autoRenewal": {
      "description": "Nach Ablauf der Mindestlaufzeit von {months} Monaten verlängert sich dein Abonnement automatisch um jeweils einen Monat, bis du es kündigst."
    },
    "autoRenewalCancellation": {
      "description": "Du kannst die automatische Verlängerung jederzeit kündigen, beachte jedoch bitte, dass eine nicht rückerstattungsfähige Mindestzahlung von {months} Monaten erforderlich ist. Mit deiner Anmeldung erklärst du dich damit einverstanden, den Dienst für {months} Monate zu nutzen und verpflichtest dich, die entsprechende Zahlung zu leisten.<br>Kündigungen müssen spätestens am letzten Tag des Monats für den Folgemonat eingereicht werden."
    },
    "cancellation": {
      "description": "Während der 7-tägigen kostenlosen Testphase hast du die Möglichkeit, dein Abonnement zu kündigen. Nach Ablauf der Testzeit kannst du die automatische Verlängerung jederzeit kündigen, beachte jedoch bitte, dass eine nicht rückerstattungsfähige Mindestzahlung von {months} Monaten erforderlich ist. Mit deiner Anmeldung erklärst du dich damit einverstanden, den Dienst für {months} Monate zu nutzen und verpflichtest dich, die entsprechende Zahlung zu leisten."
    },
    "card": {
      "benefits": {
        "benefit3": "Einblick in die Inseratsnachfrage",
        "benefit4": "Mit dem Verifiziert-Etikett Aufmerksamkeit erregen",
        "benefit6": "Rabatt für Reinigungs- und Umzugsdienste",
        "benefit7": "Gratis Nachsendung der Post für 6 Monate"
      },
      "caption3months": {
        "text": "Im 3-Monats-Abonnement enthalten"
      },
      "caption6months": {
        "text": "Im 6-Monats-Abonnement enthalten"
      },
      "captionMobile": {
        "text": "Im 6- und 3-Monats-Abonnement enthalten"
      },
      "duration": {
        "title": "{months} Monate"
      },
      "info": "Info",
      "notIncluded": {
        "text": "Nicht inbegriffen:"
      },
      "period": "3-monatiges Abonnement",
      "perMonth": "Monat",
      "price": {
        "text": "CHF {price}"
      },
      "recommended": "Empfohlen",
      "subcriptionType": "monatlich"
    },
    "cta": {
      "back": "Zurück",
      "continue": "Weiter",
      "startFreeTrial": "Probeabo starten"
    },
    "header": "Schneller zum Traumhaus",
    "invoicing": {
      "description": "Die erste Monatsrechnung wird innerhalb von 7 Tagen ausgestellt. Nachfolgende Rechnungen werden zu Beginn jedes weiteren Abonnementmonats erstellt."
    },
    "modal": {
      "cancelationNote": "1 Tag Kündigungsfrist",
      "header1": "Mindestlaufzeit Abo",
      "header2": "Probezeit",
      "header3": "Beginn der Rechnungsstellung",
      "header4": "Was du bekommst",
      "header5": "Rechnungsstellung",
      "header6": "Abonnement Verlängerung",
      "header7": "Kündigung",
      "paidSubcriptionFeature4": "Gratis Betreibungsauszug",
      "readmoreLink": "Bedingungen und Konditionen",
      "subcriptionFeature3": "Die Möglichkeit, Besichtigungen online zu buchen",
      "subcriptionFeature4": "Gratis-Betreibungsauszug nach Start des kostenpflichtigen Abos",
      "subcriptionFeature5": "Rabatt für Reinigungs- und Umzugsdienste",
      "subcriptionFeature5-1": "Gutschein für CHF {price} für Reinigungs- und Umzugsservice und einen reibungslosen Umzug oder",
      "subcriptionFeature5-2": "CHF {price} für professionelle Umzugsservices",
      "subcriptionFeature5-3": "CHF {price} für professionelle Reinigungsservices",
      "subcriptionFeature6": "Gratis Nachsendung der Post für 6 Monate",
      "subcriptionPrice": "CHF {price} monatlich",
      "subcriptionStart": "nach Ablauf der 7-tägigen Probezeit",
      "subcriptionTrialPeriod": "7 Tage",
      "subcriptionType": "{months}-monatiges Abonnement",
      "title": "MieterPlus",
      "paidSubcriptionStart": "Am Tag, an dem das Abo startet",
      "subcriptionFeature7": "Ganz oben in der Nachrichtenliste des Inserenten erscheinen"
    },
    "trialButton": "Probeabo starten",
    "trialDescription": "Du kannst dein Probeabo jederzeit kündigen. Die Rechnungsstellung beginnt nach Ablauf der 7-tägigen Probezeit.",
    "trialHeader": "7 Tage gratis testen"
  },
  "signup": {
    "goBack": "Zurück",
    "message": {
      "error": {
        "text": "Bitte versuchs später nochmals",
        "title": "Die Anmeldung für MieterPlus hat nicht geklappt"
      },
      "success": {
        "text": "Wir richten dein Abo ein. Das kann einen Moment dauern.",
        "title": "Geschafft!"
      }
    },
    "tryAgain": "Erneut versuchen"
  },
  "validation": {
    "betweenMinMaxCharacters": "Mindestens {minCharacterCount} und maximal {maxCharacterCount} Zeichen.",
    "dateFormat": "Ungültiges Datumsformat: DD.MM.JJJJ",
    "futureDate": "Bitte zukünftiges Datum oder ‘sofort’ wählen.",
    "integerRequired": "Bitte gib eine runde Zahl ohne Nachkommastellen ein.",
    "invalidDate": "Bitte trage ein gültiges Datum ein.",
    "invalidEmail": "Bitte trage eine gültige E-Mail-Adresse ein.",
    "invalidInput": "Bitte gib einen gültigen Wert ein.",
    "invalidYear": "Bitte trage ein gültiges Jahr ein.",
    "invalidZipCode": "Bitte gib eine gültige PLZ ein.",
    "maxCharacters": "Bitte schreibe höchstens {maxCharacterCount} Zeichen.",
    "maxValue": "Bitte gib einen Wert unter {maxValue} ein.",
    "minCharacters": "Bitte gib mindestens {minCharacterCount} Zeichen ein.",
    "objectRefDisallowedCharacters": "Referenz verwendet ungültige Zeichen",
    "phoneFormat": "Format ist ungültig. Bitte nur Zahlen und Leerzeichen benutzen",
    "requiredField": "Bitte fülle das Feld {fieldName} aus.",
    "unsupportedCharacters": "Einige Zeichen werden nicht unterstützt. Bitte entferne Emojis und Sonderzeichen.",
    "url": "Wir benötigen ein gültiges URL-Format (beginnend mit https:// oder http://).",
    "urlWithHttps": "Wir benötigen ein gültiges URL-Format (beginnend mit https://).",
    "youtubeUrlFormat": "Gültiges Youtube Video Link hinzufügen."
  }
}
